import { FC, ReactNode } from 'react';
import { Check } from 'lucide-react';

type IntentCardProps = {
  active: boolean;
  onClick: () => void;
  label: string;
  caption: string;
  value?: string;
  adjustLabel?: string;
  icon?: ReactNode;
  accent?: boolean;
  disabled?: boolean;
};

const IntentCard: FC<IntentCardProps> = ({
  active,
  onClick,
  label,
  caption,
  value,
  adjustLabel,
  icon,
  accent,
  disabled,
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={`incentive-offer-sell-units-panel__intent-card${
      active ? ' incentive-offer-sell-units-panel__intent-card--active' : ''
    }`}
  >
    <span
      className={`incentive-offer-sell-units-panel__intent-check${
        active ? ' incentive-offer-sell-units-panel__intent-check--active' : ''
      }`}
    >
      <Check size={12} strokeWidth={3} />
    </span>
    <span className="text-dark fw-semibold fs-14px">{label}</span>
    <span className="text-soft fs-12px mt-1">{caption}</span>
    <span className="incentive-offer-sell-units-panel__intent-footer tnum">
      {value ? (
        <span className={accent ? 'text-info' : 'text-secondary'}>{value}</span>
      ) : (
        <span className="d-inline-flex align-items-center text-primary">
          {icon}
          <span className="ml-1">{adjustLabel}</span>
        </span>
      )}
    </span>
  </button>
);

export default IntentCard;
